import { IconButton } from '@chakra-ui/react'

import { GuideIcon } from '@!/components/Icon'

export const Guide = () => {
  return <IconButton aria-label="初めての方へ" color="label.primary" icon={<GuideIcon width="38px" height="42px" />} variant="link" as="a" href="/guide" />
}
